import { createSlice } from "@reduxjs/toolkit";
import { ToSearch } from "../actions/search.actions";

const initialState = {
  searchList: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const searchSlice = createSlice({
  name: "search",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(ToSearch.pending, (state) => {
      state.searchList = { list: [], status: "idle" };
    });
    builder.addCase(ToSearch.fulfilled, (state, action) => {
      state.searchList = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(ToSearch.rejected, (state, action) => {
      state.searchList = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default searchSlice.reducer;
